import React from 'react';
import TabsMapsBase from './TabsMaps';

const TabsMaps = props => <TabsMapsBase {...props} />;

export default TabsMaps;
